<template>
  <div id="sectionContact" :class="$style.sectionContact">
    <div class="section container">
      <div class="contact--1x2">
        <div>
          <DingBeautySectionTitle title="立即試用，感受差異，<br>開啟您的美業管理新旅程！" sub-title="Ready to start?"></DingBeautySectionTitle>
          <img class="contact-img" src="@assets/images/home/formdevice_v2@2x.png" alt="" />
        </div>

        <div class="mobile-wrapper">
          <div class="pc-wrapper-1">
            <h2 class="contact__title">專人聯繫</h2>
            <p class="contact__sub-title">立即填寫諮詢表單，我們將盡快安排人員與您聯繫，<br class="pc-only" />替您解答所有問題，解鎖美業管理新型態！</p>
          </div>

          <el-form ref="contactForm" :model="contactForm" :rules="rules">
            <div class="pc-wrapper-1">
              <p class="label">您的大名*</p>
              <el-form-item prop="name" class="is-no-asterisk">
                <el-input v-model="contactForm.name"></el-input>
              </el-form-item>

              <p class="label">店家名稱*</p>
            </div>
            <el-form-item prop="title" class="is-no-asterisk">
              <el-input v-model="contactForm.title"></el-input>
            </el-form-item>

            <p class="label">產業別(可複選)*</p>
            <el-form-item prop="indsutry">
              <el-checkbox-group v-model="contactForm.indsutry">
                <el-checkbox label="美容護膚"></el-checkbox>
                <el-checkbox label="美體SPA"></el-checkbox>
                <el-checkbox label="美髮造型"></el-checkbox>
                <el-checkbox label="美甲美睫"></el-checkbox>
                <el-checkbox label="專業醫美"></el-checkbox>
                <el-checkbox label="日曬美黑"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <p class="label">電子郵件地址*</p>
            <el-form-item prop="email" class="is-no-asterisk">
              <el-input v-model="contactForm.email"></el-input>
            </el-form-item>

            <p class="label">聯絡電話*</p>
            <el-form-item prop="phone" class="is-no-asterisk">
              <el-input v-model="contactForm.phone"></el-input>
            </el-form-item>

            <p class="label">Line ID</p>
            <el-form-item prop="lineId" class="is-no-asterisk">
              <el-input v-model="contactForm.lineId"></el-input>
            </el-form-item>

            <p class="label">您的主需求*</p>
            <el-form-item prop="necessary">
              <el-radio-group v-model="contactForm.necessary">
                <el-radio label="新店導入預約系統"></el-radio>
                <el-radio label="店內更新系統"></el-radio>
                <el-radio label="客製化系統功能"></el-radio>
              </el-radio-group>
            </el-form-item>

            <p class="label">留言訊息*</p>
            <el-form-item prop="message" class="is-no-asterisk">
              <el-input v-model="contactForm.message"></el-input>
            </el-form-item>

            <el-form-item class="is-no-asterisk" style="margin-bottom: 0;">
              <el-button type="primary" class="dingbeauty-btn" :disabled="isSend" @click="submitForm">{{ isSend ? '已成功送出訊息' : '送出訊息' }}</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <GoogleReCaptchaV3 id="contact_us_captcha" ref="captcha" v-model="contactForm.g_recaptcha_response" :site-key="googleReCaptcha.siteKey" :inline="false" action="contact_us"></GoogleReCaptchaV3>
    <img class="img-left" src="@assets/dingbeauty-images/home/background01@1.png" alt="" />
    <img class="img-right" src="@assets/dingbeauty-images/home/background01@1.png" alt="" />
  </div>
</template>

<script>
import DingBeautySectionTitle from '@components/DingBeauty/DingBeautySectionTitle.vue'
import GoogleReCaptchaV3 from '@components/GoogleReCaptchaV3'

export default {
  components: { DingBeautySectionTitle, GoogleReCaptchaV3 },
  data() {
    return {
      isSend: false,
      contactForm: {
        name: '',
        title: '',
        indsutry: [],
        email: '',
        phone: '',
        lineId: '',
        necessary: '',
        message: '',
        g_recaptcha_response: '',
      },
      rules: {
        name: { required: true, message: '請輸入大名', trigger: ['blur', 'change'] },
        title: { required: true, message: '請輸入店家名稱', trigger: ['blur', 'change'] },
        indsutry: { required: true, message: '請勾選產業別', trigger: ['blur', 'change'] },
        email: { required: true, message: '請輸入電子郵件', trigger: ['blur', 'change'] },
        phone: { required: true, message: '請輸入聯絡電話', trigger: ['blur', 'change'] },
        necessary: { required: true, message: '請勾選主需求', trigger: ['blur', 'change'] },
        message: { required: true, message: '請輸入留言訊息', trigger: ['blur', 'change'] },
      },
      googleReCaptcha: {
        siteKey: '6Lf2LlcbAAAAANb1gKClQNEbRRAjU5RfIJ3sIm3v',
      },
    }
  },
  computed: {
    options() {
      return [{ title: '產業別', value: this.contactForm.indsutry.join(', ') }, { title: '您的主需求', value: this.contactForm.necessary }]
    },
  },

  mounted() {
    if (this.$route.hash === '#sectionContact') {
      setTimeout(() => {
        document.querySelector('#sectionContact').scrollIntoView()
      }, 300)
    }
  },
  methods: {
    submitForm() {
      this.$refs.contactForm.validate((isValid) => {
        if (isValid) this.sendContactData()
        else console.log('something went wrong')
      })
    },

    async sendContactData() {
      await this.$store
        .dispatch('send/sendContact', {
          ...this.contactForm,
          options: this.options,
        })
        .then((response) => {
          this.$notify({
            title: '已送出訊息',
            message: '您的訊息已成功送出，我們將盡快回覆您',
            iconClass: 'successIcon',
            customClass: 'isStyleBase',
            offset: 100,
          })
          this.isSend = true
        })
    },
  },
}
</script>

<style lang="scss" module>
$color-primary: #e3c192;

.sectionContact {
  position: relative;
  background: rgb(246, 240, 232);
  background: linear-gradient(180deg, rgba(246, 240, 232, 1) 0%, rgba(255, 255, 255, 1) 100%);

  :global {
    .pc-only {
      display: none;
    }

    input {
      color: #0c1c30;
    }

    .img-left,
    .img-right {
      display: none;
    }

    .el-input__inner {
      border: none;
      border-radius: 0;
      border-bottom: 1px solid #dcdfe6;
      background-color: transparent;
      padding: 0;

      &:focus {
        border-color: $color-primary;
      }
    }

    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: $color-primary;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner {
      background-color: $color-primary;
      border-color: $color-primary;
    }

    .el-checkbox__inner {
      background-color: transparent;
    }

    .el-checkbox__inner:hover {
      border-color: $color-primary;
    }

    .el-radio-group {
      display: grid;
      margin-top: 16px;
    }

    .el-radio__input.is-checked + .el-radio__label {
      color: $color-primary;
    }

    .el-radio__input.is-checked .el-radio__inner {
      background-color: $color-primary;
      border-color: $color-primary;
    }

    .el-radio__inner {
      background-color: transparent;
    }

    .el-radio__inner:hover {
      border-color: $color-primary;
    }

    .el-button--primary.dingbeauty-btn {
      width: 100%;
      background-color: $color-primary;
      border-color: $color-primary;
      transition: all 0.3s;
      border-radius: 0;

      &:hover {
        background-color: #ccae83;
      }

      span {
        color: #fff;
      }
    }

    span {
      color: $color-text-1;
    }

    .contact--1x2 {
      display: grid;
      gap: 32px;
    }

    .mobile-wrapper {
      border: 1px solid $color-primary;
      padding: 50px 20px;
    }

    .contact-img {
      width: 100%;
      max-width: 580px;
      justify-self: center;
    }

    .contact__title {
      font-size: 18px;
      margin-bottom: 30px;
    }

    .contact__sub-title {
      font-size: 13px;
      margin-bottom: 30px;
      color: #545662;
    }

    .label {
      font-size: 12px;
      margin: 0;
      color: #545662;
    }
  }
}

@media (min-width: 992px) {
  .sectionContact {
    :global {
      .pc-only {
        display: inline;
      }

      .contact--1x2 {
        grid-template-columns: 1fr 1fr;
      }

      .contact__title {
        font-size: 23px;
      }

      .contact-img {
        margin-top: 16px;
      }

      .mobile-wrapper {
        padding: 60px 40px;
      }
    }
  }
}

@media (min-width: 1400px) {
  .sectionContact {
    :global {
      .img-left,
      .img-right {
        position: absolute;
        display: block;
      }

      .img-left {
        bottom: 23%;
        left: 0;
        transform: rotate(180deg);
        width: 200px;
      }

      .img-right {
        bottom: 3%;
        right: 0;
        width: 240px;
      }
    }
  }
}
</style>
